export default "__VITE_ASSET__CvZJmCrq__"